import { ColumnConfig, LedgerColumnKey } from '../model';

export const ledgerConfig: Record<LedgerColumnKey, ColumnConfig> = {
  documentNumber: {
    name: 'Document Number',
    isComponent: true,
    headerExtra: {
      type: 'info',
      details: 'Ledger transaction Number',
      title: 'DOCUMENT TYPE',
    },
  },
  date: {
    name: 'Date',
    sortField: 'date',
  },
  division: {
    name: 'Division',
    // headerExtra: {
    //   type: 'info',
    //   details: '',
    //   title: '  Division',
    // },
  },
  documentType: {
    name: 'Document Type',
    headerExtra: {
      type: 'info',
      details: 'Ledger transaction Type',
      title: 'DOCUMENT TYPE',
    },
    isComponent: true,
  },
  debited: {
    name: 'Debited',
    alignment: 'flex-end',
    headerExtra: {
      type: 'info',
      details: 'Debited amount: Payment & Credit Note Transaction',
      title: 'DEBITED',
    },
    sortField: 'debited',
  },
  credited: {
    name: 'Credited',
    alignment: 'flex-end',
    headerExtra: {
      type: 'info',
      details: 'Credited amount: Invoice & Debit Note Transaction',
      title: 'CREDITED',
    },
    sortField: 'credited',
  },

  balance: {
    name: 'Balance',
    alignment: 'flex-end',
    headerExtra: {
      type: 'info',
      details: 'Remaining amount to pay',
      title: 'BALANCE',
    },
    sortField: 'balance',
  },
  referenceNumber: {
    name: 'Reference Number',
  },
  clearingDate: {
    name: 'Clearing Date',
    isAdditional: true,
    isVisible: false,
  },
  action: {
    name: 'Actions',
    alignment: 'center',
  },
};
